import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "file-list-wrap"
};
const _hoisted_2 = {
  key: 0,
  class: "tips"
};
const _hoisted_3 = {
  class: "lf"
};
const _hoisted_4 = {
  class: "tip-title"
};
const _hoisted_5 = {
  class: "c1"
};
const _hoisted_6 = {
  class: "c2"
};
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_card = _resolveComponent("el-card");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_card, {
    shadow: "hover"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      inline: true,
      class: "",
      size: "small"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "需求名称:"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.queryParam.demandName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.queryParam.demandName = $event),
          size: "small",
          placeholder: "请输入需求名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: $setup.submitForm
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("查询", -1)]))]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }), $props.actionType != '3' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[5] || (_cache[5] = _createElementVNode("i", {
      class: "el-icon-info"
    }, null, -1)), _createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createTextVNode(" 已选择 ", -1)), _createElementVNode("b", _hoisted_5, _toDisplayString(_ctx.multiSelection.length), 1), _cache[4] || (_cache[4] = _createTextVNode(" 项 | 总计文件数量：", -1)), _createElementVNode("b", _hoisted_6, _toDisplayString(_ctx.tableData.length), 1)])]), $props.actionType != '3' ? (_openBlock(), _createBlock(_component_el_dropdown, {
      key: 0,
      trigger: "click"
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
          onClick: $setup.stopAll
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("全部暂停/开始", -1)]))]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_dropdown_item, {
          onClick: $setup.cancelAll
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("全部取消", -1)]))]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "el-dropdown-link rt"
      }, [_createTextVNode(" 批量操作"), _createElementVNode("i", {
        class: "el-icon-arrow-down el-icon--right rt-icon"
      })], -1))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_el_table, {
      ref: "multipleTable",
      data: _ctx.tableData,
      "tooltip-effect": "dark",
      height: "800",
      size: "medium",
      onSelectionChange: $setup.handleSelectionChange
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        type: "selection",
        width: "%5"
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (item, index) => {
        return _openBlock(), _createBlock(_component_el_table_column, {
          key: index,
          prop: item.prop,
          label: item.label,
          width: "%20"
        }, null, 8, ["prop", "label"]);
      }), 128)), _createVNode(_component_el_table_column, {
        prop: "status",
        label: "状态",
        width: "%20",
        formatter: $setup.formatterStatus
      }, null, 8, ["formatter"]), $props.actionType != '3' ? (_openBlock(), _createBlock(_component_el_table_column, {
        key: 0,
        label: "操作",
        width: "%10"
      }, {
        default: _withCtx(scope => [$setup.matchState(scope.row.status, $props.actionType) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          link: "",
          size: "small",
          plain: "",
          onClick: $event => $setup.handleStart(scope.row.status, scope.$index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($props.startBtn), 1)]),
          _: 1
        }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          link: "",
          size: "small",
          plain: "",
          onClick: $event => $setup.handleStart(scope.row.status, scope.$index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($props.uploadBtn), 1)]),
          _: 1
        }, 8, ["onClick"])), _createVNode(_component_el_button, {
          link: "",
          size: "small",
          onClick: $event => $setup.handleCancel(scope.row, scope.$index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($props.cancelBtn), 1)]),
          _: 1
        }, 8, ["onClick"]), scope.row.status == '1' && $props.actionType == '3' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          link: "",
          size: "small",
          plain: "",
          onClick: $event => $setup.showPreviewDialog(scope.row.srcInnUrl)
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" 查看素材 ", -1)]))]),
          _: 1
        }, 8, ["onClick"])) : scope.row.status == '0' && $props.actionType == '3' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          link: "",
          size: "small",
          plain: "",
          onClick: $event => $setup.showPreviewDialog(scope.row.srcInnUrl)
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" 查看素材 ", -1)]))]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data", "onSelectionChange"])]),
    _: 1
  })])]), _createVNode(_component_el_dialog, {
    title: "预览",
    modelValue: _ctx.previewShow,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.previewShow = $event),
    width: "540px"
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      src: _ctx.imgUrl,
      width: "500"
    }, null, 8, _hoisted_7)]),
    _: 1
  }, 8, ["modelValue"])], 64);
}